<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Auditorías</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content vgt-no-overflow">
                <vue-good-table :columns="[
                    {
                        label : 'Fecha',
                        field : 'fecha_evento',
                        filterable : true,
                    },
                    {
                        label : 'Usuario',
                        field : 'usuario.nombre',
                        filterable : true,
                    },
                        {
                        label : 'Evento',
                        field : 'descripcion_evento',
                        filterable : false
                    } 
                ]"
                :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'siguiente',
                        prevLabel: 'anterior',
                        rowsPerPageLabel: 'Registros por página',
                        ofLabel: 'de',
                        allLabel: 'Todo'
                    }"
                :rows="auditorias"
                :search-options="{
                    enabled: true,
                    placeholder: 'Buscar...'
                }"
                styleClass="vgt-table vgt-table--sticky">
                </vue-good-table>
            </div>
        </div>
        <div class="modal-buttons">
            <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>Cancelar</span></button>
        </div>
    </div>
</template>

<script>
export default {
    props : [
        'id_comprobante'
    ],
    data : function () {
        return {
            url : url,
            auditorias : []
        };
    },
    methods : {
        consultar : function () {
            let that = this;
            axios.get(this.url + '/' + this.id_comprobante + '/auditorias').then(function (response) {
                that.auditorias = response.data;
            });
        }
    },
    mounted : function () {
        this.consultar();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/Auditorias.vue